export const EASE_OUT_QUINT = [0.23, 1, 0.32, 1] as const;
